import "core-js/modules/es6.symbol.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { EMPTY_PIXEL, VIDEO_SIZES } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import TitleSection from '~/components/atoms/Editorial/TitleSection.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import RegularMedia from '~/components/atoms/Editorial/RegularMedia.vue';
var COLORS = {
  grey: 'btn-dark',
  white: 'btn-white',
  transparent: 'btn-transparent'
};
export default {
  name: 'PresentationNews',
  components: {
    TitleSection,
    SimpleParagraph,
    RegularMedia
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    backgroundColor() {
      return this.payload.primary.background_color;
    },

    backgroundImage() {
      return formatPrismicImage(this.payload.primary.background_image.url);
    },

    title() {
      return this.payload.primary.title[0] || {};
    },

    textColor() {
      return this.payload.primary.title_color;
    },

    paragraph() {
      return this.payload.primary.paragraph;
    },

    readMore() {
      return this.payload.primary.read_more === 'Yes';
    },

    button() {
      return {
        text: this.payload.primary.button_text,
        color: COLORS[this.payload.primary.button_color],
        url: this.payload.primary.button_url.url,
        target: this.payload.primary.button_url.target,
        tracking: {
          data: {
            event_category: this.payload.primary.event_category,
            event_action: this.payload.primary.event_action,
            event_label: this.payload.primary.event_label
          }
        }
      };
    },

    alt() {
      return this.payload.primary.alt;
    },

    src() {
      return formatPrismicImage(this.payload.primary.image.url, ['w_1440']) || EMPTY_PIXEL;
    },

    videoImages() {
      return Object.entries(VIDEO_SIZES).reduce((acc, _ref) => {
        var [key, value] = _ref;
        return _objectSpread(_objectSpread({}, acc), {}, {
          [key]: formatPrismicImage(this.payload.primary.image.url, ["w_".concat(value)]) || EMPTY_PIXEL
        });
      }, {});
    },

    srcset() {
      var small = formatPrismicImage(this.payload.primary.image.url, ['w_375']) || EMPTY_PIXEL;
      var medium = formatPrismicImage(this.payload.primary.image.url, ['w_375,dpr_2']) || EMPTY_PIXEL;
      var large = formatPrismicImage(this.payload.primary.image.url, ['w_1440']) || EMPTY_PIXEL;
      var xlarge = formatPrismicImage(this.payload.primary.image.url, ['w_1440,dpr_2']) || EMPTY_PIXEL;
      return "".concat(small, " 375w, ").concat(medium, " 750w, ").concat(large, " 1440w, ").concat(xlarge, " 2880w");
    },

    imagePosition() {
      return this.payload.primary.image_position;
    },

    videos() {
      return {
        mp4: Object.entries(VIDEO_SIZES).reduce((acc, _ref2) => {
          var [key, value] = _ref2;
          return _objectSpread(_objectSpread({}, acc), {}, {
            [key]: formatPrismicImage(this.payload.primary.video_mp4.url, ["w_".concat(value, ",q_auto,f_auto")], '', 'video')
          });
        }, {}),
        webm: Object.entries(VIDEO_SIZES).reduce((acc, _ref3) => {
          var [key, value] = _ref3;
          return _objectSpread(_objectSpread({}, acc), {}, {
            [key]: formatPrismicImage(this.payload.primary.video_webm.url, ["w_".concat(value, ",q_auto,f_auto")], '', 'video')
          });
        }, {}),
        auto_play: this.payload.primary.video_auto_play === 'Yes',
        play_color: this.payload.primary.video_play_color,
        mute_video: this.payload.primary.mute_video
      };
    }

  }
};